<div class="flex flex-col items-center justify-center">
  <div class="flex items-center gap-3">
    @if (loading) {
      <ngx-skeleton-loader
        class="block h-[40px]"
        [theme]="{
          height: '40px',
          width: '140px',
          'margin-bottom': '0px',
        }"
      ></ngx-skeleton-loader>
    } @else {
      <p class="text-4xl font-bold">
        {{ unitPrice | currency: 'EUR' : 'symbol' : '1.2-2' : 'de-DE' }}
      </p>
    }
    <div class="flex flex-col justify-center text-sm">
      <p class="text-grey">{{ 'product.dialog.price.perUser' | transloco }}</p>
      <p class="text-grey">{{ 'product.dialog.price.perYear' | transloco }}</p>
    </div>
  </div>
  <div class="mt-2 flex items-center gap-2 text-sm">
    <span class="text-grey"
      >x {{ productDataService.quantity() }}
      {{ 'product.dialog.price.users' | transloco }} =
    </span>
    @if (loading) {
      <ngx-skeleton-loader
        class="inline-block h-5"
        [theme]="{
          width: '90px',
          height: '20px',
          'margin-bottom': '0px',
        }"
      ></ngx-skeleton-loader>
    } @else {
      <span class="font-bold">
        {{
          totalPriceWithoutTaxAndDiscount
            | currency: 'EUR' : 'symbol' : '1.2-2' : 'de-DE'
        }}
      </span>
    }
  </div>
</div>
